module.exports = __webpack_public_path__ + "static/media/Upload button.2f4d9a19.svg";